<template>
  <div class="projects-view-container">
    <h1>Projects</h1>
    <div class="projects-list">
      <div v-for="doc in documents" :key="doc.id" class="project">
        <h2>{{ doc.title }}</h2>
        <img :src="doc.thumbnailUrl" alt="project thumbnail" />
      </div>
    </div>
  </div>
</template>

<script>
import getCollection from '@/composables/getCollection';
export default {
  setup() {
    const { documents } = getCollection('projects');
    console.log('Fetched documents:', documents); // Debugging line
    return {
      documents,
    };
  },
};
</script>

<style scoped>
.projects-view-container {
  padding: 20px;
}

.projects-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px; /* Adds space between grid items */
}

.project {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  cursor: pointer;
  width: 100%; /* Ensures each grid item fills the allocated space */
  box-sizing: border-box; /* Includes padding and border in width/height calculations */
}

.project h2 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  font-weight: 500;
  text-align: center; /* Optional: Align title text */
}

.project img {
  width: 100%; /* Makes the image responsive to the card's width */
  height: auto; /* Maintains the aspect ratio */
  max-height: 300px; /* Ensures consistent image height */
  object-fit: cover; /* Crops the image to fit the container */
  border-radius: 5px;
}
</style>
